import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import download from 'downloadjs'
import { isInApp, actOpenSysBrowser } from './appSDK'
import { upyun } from '../filters/index'
import { getCreateStoreAccess } from './orderCreateRuntime'

/**
 * 判断是否为自取店地址（不可用）
 * @param {string} desc 地址描述
 * @returns {boolean} 是否为自取店地址
 */
export function isSelfStoreAddr (desc) {
  // 用戶會把門牌寫成中文數字「十三號」繞過限制，統一成阿拉伯數字後再比對
  const normalizedDesc = desc.replace(/\s/g, '').replace(/化成路十三號/g, '化成路13號')

  // 化成路13號的特殊判斷邏輯
  const isHuaChengRoad13Blocked = (() => {
    if (normalizedDesc === '化成路13號') return true // 完全等於化成路13號，不可選
    const floorMatch = normalizedDesc.match(/化成路13號(\d+)楼/)
    if (floorMatch) {
      const floor = parseInt(floorMatch[1])
      return floor === 1 // 1楼不可選，其他楼层可選
    }
    return normalizedDesc.indexOf('化成路13號') > -1 // 其他包含化成路13號的情況不可選
  })()

  // 力行路385巷51弄28號的特殊判斷邏輯
  const isLiXingRoad385Blocked = (() => {
    if (normalizedDesc === '力行路385巷51弄28號') return true // 完全等於，不可選
    const floorMatch = normalizedDesc.match(/力行路385巷51弄28號(\d+)楼/)
    if (floorMatch) {
      const floor = parseInt(floorMatch[1])
      return floor === 1 // 1楼不可選，其他楼层可選
    }
    return normalizedDesc.indexOf('力行路385巷51弄28號') > -1 // 其他包含的情況不可選
  })()

  // 台中市西屯區環中路二段28號
  const isHuanZhongRoad28Blocked = normalizedDesc.indexOf('環中路二段28號') > -1

  // 其他自取店地址
  const isOtherSelfStore = normalizedDesc.indexOf('南興路1372號') > -1 ||
                          normalizedDesc.indexOf('建興路337號') > -1 ||
                          normalizedDesc.indexOf('福澳村51-1號') > -1

  return isHuaChengRoad13Blocked || isLiXingRoad385Blocked || isOtherSelfStore || isHuanZhongRoad28Blocked
}

/**
 * 是否可使用
 * @param {*} item
 */
export function canUse (item) {
  if (item.tag === 'tradevan') return false

  // if (!item.isSameTradevan) {
  //   return false
  // }

  // 自取店地址不可用
  if (isSelfStoreAddr(item.desc)) {
    return false
  }

  // if (item.tradevanAddr.blocks && item.tradevanAddr.blocks.length) return false
  // const extraInfo = typeof item.extraInfo === 'string' ? JSON.parse(item.extraInfo) : item.extraInfo
  // const isLocked = extraInfo && extraInfo.tradevanAddr && extraInfo.tradevanAddr.addrid ? extraInfo.tradevanAddr.isLocked : item.isLocked
  return item && String(item.isInvalid) === '0'
}

/**
 * 拆分姓名、統編、電話、地址
 */
export function splitFullAddrStr (str) {
  const r = {
    consignee: '',
    mobile: '',
    // idNum: '',
    city: '',
    district: '',
    desc: '',
  }

  const mobileExec = /(09\d{8})/.exec(str)
  if (mobileExec) {
    r.mobile = mobileExec[1]
    str = str.replace(r.mobile, '') // 去掉手機號  以免跟 idNum 衝突
  }

  let idExec
  if (!idExec) {
    idExec = /([a-zA-Z]{2}\d{8})/.exec(str) // 居留证
  }
  if (!idExec) {
    idExec = /([a-zA-Z]\d{9}|\d{8,10})/.exec(str) // 身份证
  }
  if (!idExec) {
    idExec = /(\d{8})/.exec(str) // 公司营业执照号
  }
  if (idExec) {
    // r.idNum = idExec[1]
  }

  const consigneeExec = /(?:\s|^)([\u3400-\u9fa5]{2,4})(?:\s|$)/.exec(str)
  if (consigneeExec) {
    r.consignee = consigneeExec[1]
  }

  const addrExec = /(?:\s|^)([\u3400-\u9fa5]{2}[市縣島])([\u3400-\u9fa5]{1,3}[區鄉鎮市島])(.*?)(:?\s|$)/.exec(str)
  if (addrExec) {
    r.city = addrExec[1]
    r.district = addrExec[2]
    r.desc = addrExec[3]
  }

  return r
}

/**
 * 解析國內地址
 * @param {*} str
 */
export function splitFullCnAddrStr (str) {
  const r = {
    name: '',
    mobile: '',
    address: '',
  }

  const mobileExec = /(1\d{10})/.exec(str)
  if (mobileExec) {
    r.mobile = mobileExec[1]
    str = str.replace(r.mobile, '')
  }

  const consigneeExec = /(?:\s|^)([\u3400-\u9fa5]{2,4})(?:\s|$)/.exec(str)
  if (consigneeExec) {
    r.name = consigneeExec[1]
  }

  const addrExec = /(?:\s|^)([\u3400-\u9fa5]*[省市区區])(.*?)(:?\s|$)/.exec(str)
  if (addrExec) {
    r.address = addrExec[0].trim()
  }

  return r
}

export function stationError (item) {
  const arr = []
  if (!(2 & item.isLocked)) {
    arr.push('黑貓')
  }
  if (!(4 & item.isLocked)) {
    arr.push('新竹')
  }
  return arr.join('、')
}

function getTextImg (text) {
  const canvas = document.createElement('canvas')
  canvas.width = 1000
  canvas.height = 150
  const ctx = canvas.getContext('2d')
  ctx.font = '48px serif'
  ctx.fillText(text, 0, 50, 900)
  // return fetch('https://pdf-lib.js.org/assets/minions_banana_alpha.png').then(res => res.arrayBuffer())
  return fetch(canvas.toDataURL()).then(res => res.arrayBuffer())
}

export async function downLetterOfAuthorization ({ addr, tradevanAddr }) {
  if (!tradevanAddr) {
    tradevanAddr = addr
    if (addr.extraInfo && addr.extraInfo.tradevanAddr) {
      tradevanAddr = addr.extraInfo.tradevanAddr
    }
  }
  const isCompany = isCompanyAddr(tradevanAddr.idNum)
  const url = 'https://static.kkren.com.tw/static/pdf/letter_of_authorization.pdf'

  const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

  const pdfDoc = await PDFDocument.load(existingPdfBytes)

  const pages = pdfDoc.getPages()
  const firstPage = pages[0]
  const { width, height } = firstPage.getSize()
  console.log(width, height)

  if (isCompany) {
    const consigneeImage = await pdfDoc.embedPng(await getTextImg(tradevanAddr.consignee))
    const pngDims = consigneeImage.scale(0.3)
    firstPage.drawImage(consigneeImage, {
      x: 90,
      y: firstPage.getHeight() - 138,
      width: pngDims.width > 240 ? 240 : pngDims.width,
      height: pngDims.height,
    })

    firstPage.drawImage(consigneeImage, {
      x: 105,
      y: firstPage.getHeight() - 515,
      width: pngDims.width,
      height: pngDims.height,
    })

    // firstPage.drawImage(consigneeImage, {
    //   x: 195,
    //   y: firstPage.getHeight() - 532,
    //   width: pngDims.width,
    //   height: pngDims.height,
    // })
  }

  const idNumImage = await pdfDoc.embedPng(await getTextImg(tradevanAddr.idNum))
  const idNumImageDims = idNumImage.scale(0.3)
  firstPage.drawImage(idNumImage, {
    x: 175,
    y: firstPage.getHeight() - 552,
    width: idNumImageDims.width,
    height: idNumImageDims.height,
  })

  // let addrText = `${addr.city}${addr.district}${addr.desc}`
  let addrText = ''
  if (isCompany) {
    addrText = ''
    const res = await window.vueApp.$store.dispatch('address/natGcisCmpyDetail', {
      banNo: tradevanAddr.idNum
    })
    if (!res.data.error) {
      addrText = res.data.model.address || ''
    }
  }

  const addrImage = await pdfDoc.embedPng(await getTextImg(addrText))
  const addrImageDims = addrImage.scale(0.3)
  firstPage.drawImage(addrImage, {
    x: 150,
    y: firstPage.getHeight() - 570,
    width: addrImageDims.width,
    height: addrImageDims.height,
  })

  const mobileImage = await pdfDoc.embedPng(await getTextImg(tradevanAddr.mobile))
  const mobileImageDims = mobileImage.scale(0.3)
  firstPage.drawImage(mobileImage, {
    x: 200,
    y: firstPage.getHeight() - 590,
    width: mobileImageDims.width,
    height: mobileImageDims.height,
  })

  const pdfBytes = await pdfDoc.save()
  if (isInApp()) {
    const file = new Blob([pdfBytes], { type: 'application/pdf' })
    window.vueApp.$store.dispatch('upyun/uploadImg', {
      file,
      noLimitName: true,
      policyParams: {
        dir: 'temp',
        ext: 'pdf',
      }
    }).then(res => {
      const url = upyun(res.data.url)
      actOpenSysBrowser(url)
    })
  } else {
    download(pdfBytes, `個案委任書-${tradevanAddr.consignee}.pdf`, 'application/pdf')
  }
  // var file = new Blob([pdfBytes], { type: 'application/pdf' })
  // var fileURL = URL.createObjectURL(file)
  // window.open(fileURL)
}

export function isCompanyAddr (idNum) {
  return /^(\d{8})$/.test(idNum)
}

export function canUsePch (model) {
  /*
新北市：新店區、樹林區、土城區、五股區、泰山區、新莊區、蘆洲區、三重區、板橋區、中和區、永和區、汐止區、林口區
桃園市：蘆竹區、桃園區
台中市：北區、東區、南區、西區、中區
*/

  const citys = `
台北市中正區
台北市大同區
台北市中山區
台北市松山區
台北市大安區
台北市萬華區
台北市信義區
台北市士林區
台北市北投區
台北市內湖區
台北市南港區
台北市文山區

新北市汐止區
新北市板橋區
新北市新店區
新北市永和區
新北市中和區
新北市土城區
新北市樹林區
新北市三重區
新北市新莊區
新北市泰山區
新北市林口區
新北市蘆洲區
新北市五股區
新北市淡水區
新北市八里區
新北市三峽區
新北市鶯歌區

桃園市桃園區
桃園市龜山區
桃園市蘆竹區
桃園市八德區
桃園市中壢區
桃園市平鎮區
桃園市楊梅區
桃園市龍潭區

新竹市
新竹縣竹北市

台中市中區
台中市東區
台中市南區
台中市西區
台中市北區
台中市西屯區
台中市南屯區
台中市北屯區
台中市太平區
台中市大里區
台中市潭子區

彰化縣彰化市

台南市北區
台南市中西區
台南市東區
台南市南區
台南市安平區
台南市永康區
台南市安南區
台南市仁德區

高雄市楠梓區
高雄市仁武區
高雄市左營區
高雄市三民區
高雄市鼓山區
高雄市前鎮區
高雄市鳳山區
高雄市苓雅區
`.split('\n').map(i => i.trim()).filter(i => i)

  // let districtStrs = ''
  // if (model.city === '台北市' || model.city === '臺北市') {
  //   districtStrs = '內湖區、南港區、文山區、大安區、中山區、大同區、信義區、松山區、萬華區、中正區、士林區'
  // } else if (model.city === '新北市') {
  //   districtStrs = '新店區、樹林區、土城區、五股區、泰山區、新莊區、蘆洲區、三重區、板橋區、中和區、永和區、汐止區、林口區'
  // } else if (model.city === '台中市' || model.city === '臺中市') {
  //   districtStrs = '北區、東區、南區、西區、中區'
  // } else if (model.city === '桃園市' || model.city === '桃園') {
  //   districtStrs = '蘆竹區、桃園區'
  // }
  // return districtStrs.split('、').includes(model.district)

  return citys.includes(`${model.city}${model.district}`.replace('臺', '台'))
}

export async function tradevanAddrCanUse (item) {
  const createStore = getCreateStoreAccess(window.vueApp.$store, window.vueApp.$store.state.project)
  // 需要认证的情况
  if (needVerify(item)) {
    return false
  }
  // 商务版只能选择公司
  if (window.vueApp.$store.state.edition === 's' && item.isCompany !== 1) {
    return false
  }
  // 有黑名单
  if (item.blocks && item.blocks.length) {
    return false
  }
  // 未通过验证
  if (!(1 & item.tradevanAddr?.isLocked)) {
    return false
  }
  if (createStore.getter('tradevansUnshipped')?.[item.idNum]) {
    return false
  }
  // 食品
  if (createStore.getter('hasPackFood') && item.isCompany === 1) {
    return false
  }

  if (!await checkLock(item)) {
    return false
  }
  return true
}

export function needVerify (item) {
  return item.isCompany && !item.label
}

async function checkLock (item) {
  const res = await window.vueApp.$store.dispatch('address/checkLock', {
    addrid: item.addrid
  })
  if (res.data.error === 'CorpNameEmpty') {
    window.vueApp.$confirm('該公司行號不可用（經營狀態非營業中）', {
      buttonFalseText: false,
    })
    return false
  } else if (res.data.error) {
    window.vueApp.$confirm(res.data.error, {
      buttonFalseText: false,
    })
    return false
  }

  item.isLocked = res.data.model.isLocked
  return true
}
